import script from "./share.policy.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./share.policy.modal.vue?vue&type=script&lang=ts&setup=true"

import "./share.policy.modal.vue?vue&type=style&index=0&id=3f6bac70&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6bac70"]])

export default __exports__